import palette from "src/theme/palette";
import typography from "src/theme/typography";

const EMPTY_OBJ = {};

const getVariantStyles = (variant) => {
  const variants = {
    dark: {
      backgroundColor: palette.system[700],
      color: palette.system[0]
    },
    light: {
      backgroundColor: palette.system[0],
      color: palette.text[800],
      padding: "16px",
      ...typography.body2
    }
  };
  return variants[variant] || variants.dark;
};

// The app's tooltip look, for MUI tooltips that can't use this component (it wraps its children in a Stack).
export const getTooltipSx = (variant = "dark", tooltipStyle = EMPTY_OBJ) => (theme) => ({
  ...getVariantStyles(variant),
  boxShadow: theme.shadows[4],
  borderRadius: "8px",
  ...(typeof tooltipStyle === "function" ? tooltipStyle(theme) : tooltipStyle),
});
